module.exports = __webpack_public_path__ + "img/Avatar-71.1e3a1d6a.svg";